import { isProd, isTalkie } from '../utils';
import { SSR_PORT } from './port';

// node api host, path must starts with /node
export const NODE_API_HOST = {
  development: `http://127.0.0.1:${SSR_PORT}`,
  test: `http://127.0.0.1:${SSR_PORT}`,
  preonline: `http://127.0.0.1:${SSR_PORT}`,
  production: `http://127.0.0.1:${SSR_PORT}`,
  unknown: `http://127.0.0.1:${SSR_PORT}`,
};

const internalServer = isTalkie
  ? `http://weaver-gateway-weaver-web.weaver.svc.cluster.local:8888`
  : isProd
    ? 'http://weaver-gateway-weaver.xingye-prod.svc.cluster.local:8888'
    : 'http://weaver-gateway-weaver.xingye-test.svc.cluster.local:8888';

// direct server api
export const SERVER_API_HOST = {
  development: `http://127.0.0.1:${SSR_PORT}`, // 先打到node，再通过node统一proxy到test，解决跨域
  test: internalServer,
  preonline: internalServer,
  production: internalServer,
  unknown: internalServer,
};

export const ROOT_DOMAIN = {
  development: 'localhost',
  test: 'xaminim.com',
  production: isTalkie ? 'talkiex.com' : 'xingyeai.com',
};

// talkie 正式环境支持的所有域名，顺序越靠前优先级越高
export const TALKIE_PRODUCTION_DOMAINS = ['talkie-ai.com', 'talkie-ai.in', 'talkiex.com'];
